/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */

export enum DataTransferMappingStatus {
  Pending = 'pending',
  Active = 'active',
  NoData = 'no_data',
}

export enum SurveyDataStatus {
  Value = 'value',
  Na = 'na',
  NoSurvey = 'no_survey',
  NotAnswered = 'not_answered',
}

export enum IntegrationValueSource {
  Connection = 'connection',
  ApiPassthrough = 'api_passthrough',
  StaticValue = 'static_value',
  ClientOverride = 'client_override',
  Derived = 'derived',
}

export interface DataTransferConnectionInfo {
  connectionCode: string;
  calculationName: string;
  variableCode: string;
  valueListCode: string;
}

export interface DataTransferValue {
  value?: string | number;
  unit?: string;
  numberScale?: string;
  /** Explanation note — written to utrv.note when applying */
  note?: string;
}

export interface DataTransferRow {
  utrCode: string;
  optionCode?: string;
  tableRowMatch?: Array<{ code: string; value: string }>;
  utrLabel: string;
  optionLabel?: string;
  valueType: string;
  connectionInfo?: DataTransferConnectionInfo;
  survey: DataTransferValue & {
    status: SurveyDataStatus;
    utrvId?: string;
    utrvStatus?: string;
    surveyId?: string;
  };
  integration: DataTransferValue & {
    source?: IntegrationValueSource;
    detail?: string;
  };
  status: DataTransferMappingStatus;
  verifiedAt?: string;
  hasDiscrepancy: boolean;
  notices: ValidationNotice[];
  internalNotes?: string;
  partnerNotes?: string;
}

export enum ValidationNoticeType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export interface ValidationNotice {
  type: ValidationNoticeType;
  code: string;
  message: string;
}

export interface DataTransferSummary {
  total: number;
  comparable: number;
  matching: number;
  differing: number;
  pending: number;
  noData: number;
}

export interface DataTransferSurveyResult {
  surveyId: string;
  label: string;
  effectiveDate: string;
  rows: DataTransferRow[];
  summary: DataTransferSummary;
}

export interface DataTransferResponse {
  surveys: DataTransferSurveyResult[];
  connectionExternalId?: string;
  childExternalId?: string;
}

export type GroupMode = 'survey' | 'question';
